{
  "es": {
    "contact": {
      "actions": {
        "accept": "Aceptar",
        "add": "Añadir contacto",
        "add_type": "Añadir {type}",
        "backInspirationLists": "Volver a las listas de inspiración",
        "cancelNew": "Deshacer",
        "deactivateEmployee": "Desactivar",
        "deleteCustomer": "Eliminar cliente...",
        "deleteEmployee": "Eliminar empleado...",
        "deleteLead": "Eliminar interesado...",
        "deletePartner": "Eliminar colaborador...",
        "delete_contact": "Eliminar",
        "edit": "Editar",
        "impersonate": "Suplantar",
        "impersonateStart": "Cruza el portal naranja para explorar el mundo de {name}.",
        "impersonateStop": "Volver a tu mundo",
        "invite": "Enviar invitación",
        "newTicket": "Nueva conversación",
        "reactivateEmployee": "Reactivar",
        "resendInvitationEmail": "Reenviar correo de invitación",
        "searchContact": "Buscar contacto",
        "searchCustomer": "Buscar cliente",
        "searchEmployee": "Buscar empleado",
        "selectAll": "Seleccionar los {total} contactos",
        "selectOption": "Seleccionar opción",
        "setProfilePicture": "Establecer foto de perfil",
        "showall": "Mostrar todo",
        "unSelectAll": "Limpiar selección."
      },
      "attributes": {
        "language": "Idioma",
        "timezone": "Zona horaria",
        "title": "Tratamiento"
      },
      "labels": {
        "address": "Dirección",
        "all": "Todos los contactos",
        "back_to_overview": "Volver a la vista general",
        "cannot_create_role": "Ponte en contacto con un propietario para crear un nuevo contacto",
        "cannot_delete": "No se puede eliminar este usuario (integración)",
        "company": "Empresa",
        "company_all": "Todas las empresas",
        "contact_status": {
          "active": "Activo",
          "added": "Aún no invitado",
          "all": "Todos los estados",
          "blocked": "Desactivado",
          "invited": "Invitado",
          "status": "Estado"
        },
        "contact_type": "Tipo",
        "customer": "Cliente",
        "customers": "Clientes",
        "employee": "Equipo",
        "export_contacts": "Exportar contactos",
        "general": "General",
        "impersonateInactiveProfile": "Esta persona genial aún no está activa. Activa primero al cliente.",
        "invite": "Sí, invitar contactos",
        "inviteProfileFirstCustomer": "Invita primero al cliente a la plataforma para poder enviar un mensaje, suplantarlo o reenviar el correo de invitación",
        "inviteProfileFirstPartner": "Invita primero al colaborador a la plataforma para poder suplantarlo o reenviar el correo de invitación",
        "last_login": "Último inicio de sesión",
        "last_seen": "visto por última vez",
        "last_seen_not_seen_yet": "sin inicio de sesión todavía",
        "lead": "Interesado",
        "name": "Nombre",
        "name_or_email_address": "Nombre o correo",
        "name_or_email_address_phone": "Nombre, correo o teléfono",
        "noContacts": "Sin contactos",
        "no_contacts": "No hay contactos para exportar",
        "no_contacts_results": "Esta búsqueda no tiene resultados. Prueba otros filtros para encontrar a la persona adecuada.",
        "no_contacts_results_subtitle": "Esta búsqueda no tiene resultados. Prueba otros filtros para encontrar a la persona adecuada.",
        "no_contacts_results_title": "No se han encontrado contactos",
        "number_contacts": "Sin contactos | 1 contacto | {count} contactos",
        "other": "Otro",
        "partner": "Colaborador",
        "partners": "Colaboradores",
        "project": "Proyecto",
        "secondary_contact": "Contacto secundario",
        "selectOne": "Selecciona al menos 1 contacto",
        "selectProjectForImpersonation": "¿Para qué proyecto quieres suplantar a {customer_name}?",
        "selected": "{selected} contacto seleccionado. | {selected} contactos seleccionados.",
        "sorting": {
          "last_name": "Nombre",
          "session_started_at": "Último inicio de sesión",
          "status": "Estado"
        },
        "totalSelected": "Los {total} contactos están seleccionados.",
        "units": "Unidades"
      },
      "navigation": {
        "backToContacts": "Volver a contactos"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Por nombre o correo"
      },
      "validation": {
        "emailTaken": "El correo es el mismo que el anterior",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "requireEmailAddress": "El correo es obligatorio"
      }
    }
  }
}
